import { render, staticRenderFns } from "./PassengersTransfers.vue?vue&type=template&id=3027f6ce&scoped=true"
import script from "./PassengersTransfers.vue?vue&type=script&lang=js"
export * from "./PassengersTransfers.vue?vue&type=script&lang=js"
import style0 from "./PassengersTransfers.vue?vue&type=style&index=0&id=3027f6ce&prod&scoped=true&lang=css"
import style1 from "./PassengersTransfers.vue?vue&type=style&index=1&id=3027f6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3027f6ce",
  null
  
)

export default component.exports